import type { Vec2 } from '../../geo/types';
import type { MooringData } from './mooredBoats';

interface Bridge {
  readonly id: string;
  readonly a: Vec2;
  readonly b: Vec2;
  readonly width: number;
}

/** Four long boats lie against the Dam-facing side of the second timber crossing from the Dam
 * in the museum scan (3310–3940 × 2510–2970). The tally includes them with the west-bank boats.
 * The corresponding source crossing is Oude Brug, after Papenbrug and before Nieuwe Brug.
 * The range along its eastern half is a fitted estimate, not surveyed berth positions. */
export function withPaintedBridgeBerths(
  mooring: MooringData,
  bridges: readonly Bridge[]
): MooringData {
  if (mooring.id !== 'mooring-damrak') return mooring;
  const bridge = bridges.find((b) => b.id === 'bridge-street-oudebrugsteeg-3');
  if (!bridge) return mooring;
  const [dx, dy] = [bridge.b[0] - bridge.a[0], bridge.b[1] - bridge.a[1]];
  const length = Math.hypot(dx, dy);
  if (length === 0) return mooring;
  // a is the eastern bank, b the western; left of a→b faces the Dam.
  const edge: Vec2 = [((-dy / length) * bridge.width) / 2, ((dx / length) * bridge.width) / 2];
  const at = (t: number): Vec2 => [bridge.a[0] + dx * t + edge[0], bridge.a[1] + dy * t + edge[1]];
  return {
    ...mooring,
    bridgeBerths: [{ path: [at(0.12), at(0.57)], side: 'left', count: 4 }],
  };
}
